/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cognito_Invitation_IntroInputs */

const en_cognito_invitation_intro = /** @type {(inputs: Cognito_Invitation_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An account was created for you on the Recobra platform. Use the credentials below for your first sign-in:`)
};

const pt_br2_cognito_invitation_intro = /** @type {(inputs: Cognito_Invitation_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma conta foi criada para você na plataforma Recobra. Use as credenciais abaixo para realizar o primeiro acesso:`)
};

/**
* | output |
* | --- |
* | "An account was created for you on the Recobra platform. Use the credentials below for your first sign-in:" |
*
* @param {Cognito_Invitation_IntroInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cognito_invitation_intro = /** @type {((inputs?: Cognito_Invitation_IntroInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognito_Invitation_IntroInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognito_invitation_intro(inputs)
	return pt_br2_cognito_invitation_intro(inputs)
});